import { licenseNumberMask } from '../../../../../backend/constants';
import { useCredentialingTranslation } from '../../../../../ui/hooks';
import { HtmlOutputContext } from '@juvare/common-form-ui/HtmlOutput';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import { Box, IconButton, Skeleton, Tooltip, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
export const DriverLicense = (props) => {
    const [showDriverLicense, setShowDriverLicense] = useState(false);
    const [driverLicense, setDriverLicense] = useState('');
    const [loading, setLoading] = useState(false);
    const { data } = useContext(HtmlOutputContext);
    const { t } = useCredentialingTranslation();
    const EyeIcon = showDriverLicense ? VisibilityOffOutlined : VisibilityOutlined;
    const toggleShowDriverLicense = () => {
        setShowDriverLicense((showDriverLicensePrev) => {
            var _a;
            if (!showDriverLicensePrev) {
                if (!props['data-driver-license']) {
                    throw new Error('Driver license is missing');
                }
                if (props['data-driver-license-decrypted'] && ((_a = props['data-driver-license-decrypted']) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true') {
                    setDriverLicense(props['data-driver-license']);
                }
                else {
                    setLoading(true);
                    data === null || data === void 0 ? void 0 : data.decryptCredentialingData(props['data-driver-license']).then((result) => {
                        setDriverLicense(result);
                    }).catch(handleErrorSnackbar).finally(() => setLoading(false));
                }
            }
            return !showDriverLicensePrev;
        });
    };
    const driverLicenseText = showDriverLicense ? driverLicense : licenseNumberMask;
    const tooltipText = !showDriverLicense ? t('driverLicense.show') : t('driverLicense.hide');
    if (!(data === null || data === void 0 ? void 0 : data.decryptCredentialingData)) {
        throw new Error('decryptCredentialingData is required');
    }
    if (!(data === null || data === void 0 ? void 0 : data.showDriverLicense)) {
        throw new Error('showDriverLicense is required');
    }
    if (props['data-handler'] === 'decryptCredentialingData' && props['data-driver-license']) {
        return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
            React.createElement(Typography, { variant: 'subtitle2', component: 'span' }, loading ? (React.createElement(Skeleton, { variant: 'text', sx: { fontSize: (theme) => theme.typography.subtitle2.fontSize, width: '50px' } })) : (driverLicenseText)),
            (data === null || data === void 0 ? void 0 : data.showDriverLicense(props['data-person-id'])) ? (React.createElement(Tooltip, { title: tooltipText },
                React.createElement("span", null,
                    React.createElement(IconButton, { color: 'primary', disabled: loading, onClick: toggleShowDriverLicense, sx: { ml: 1 } },
                        React.createElement(EyeIcon, null))))) : null));
    }
    return React.createElement(React.Fragment, null);
};
